import React from 'react'
import DepartmentDelete from "./DepartmentDelete";
import DepartmentEdit from "./DepartmentEdit";

const DepartmentActions = ({record, updater}) => {


    return (
        <React.Fragment>
            <div>
                <DepartmentEdit deptId={record.id} updater={updater}/>
                <DepartmentDelete deptId={record.id} updater={updater}/>
            </div>
        </React.Fragment>
    )
}
export default DepartmentActions